export const ANNOTATION_MENTION_MENU_MIN_WIDTH = 260;
export const ANNOTATION_MENTION_VIEW_PAD = 8;

export function placeAnnotationMentionMenu(
  anchor: Pick<DOMRect, 'left' | 'right' | 'top' | 'bottom' | 'width'>,
  viewport: { width: number; height: number },
  menuHeight?: number,
): { top: number; left: number; width: number; maxHeight: number; placement: 'above' | 'below' } {
  const pad = ANNOTATION_MENTION_VIEW_PAD;
  const width = Math.min(
    Math.max(anchor.width, ANNOTATION_MENTION_MENU_MIN_WIDTH),
    Math.max(160, viewport.width - pad * 2),
  );
  let left = anchor.left;
  left = Math.min(Math.max(pad, left), viewport.width - width - pad);

  const spaceBelow = viewport.height - anchor.bottom - pad;
  const spaceAbove = anchor.top - pad;
  const preferred = Math.min(240, Math.round(viewport.height * 0.4));
  const needed = Math.min(160, preferred);
  const openBelow = spaceBelow >= needed && spaceBelow >= spaceAbove;
  const maxHeight = Math.max(96, Math.min(preferred, openBelow ? spaceBelow : spaceAbove));
  const height = Math.min(menuHeight || maxHeight, maxHeight);
  const top = openBelow
    ? anchor.bottom + 6
    : Math.max(pad, anchor.top - height - 6);

  return {
    top,
    left,
    width,
    maxHeight,
    placement: openBelow ? 'below' : 'above',
  };
}
